var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSuccessfulResponsive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "76px",
    height: "100px",
    viewBox: "0 0 76 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(30.196078%,30.196078%,30.196078%)",
      fillOpacity: 1
    },
    d: "M 17.6875 58.917969 C 17.925781 58.832031 18.308594 59.859375 18.101562 60.652344 C 17.332031 63.5 14.21875 89.675781 12.972656 89.5 C 3.101562 88.148438 6.390625 81.480469 6.511719 81.507812 C 15.582031 85.210938 4.433594 64.175781 17.6875 58.917969 Z M 17.6875 58.917969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,91.764706%,64.705882%)",
      fillOpacity: 1
    },
    d: "M 46.589844 59.796875 C 47.628906 61.5 48.753906 65.171875 50.265625 64.9375 C 58.539062 63.5 72.917969 48.929688 74.902344 42.40625 L 62.601562 38.792969 C 60.644531 41.761719 60.523438 40.644531 58.714844 43.847656 C 56.34375 48.078125 47.597656 48.429688 44.78125 53.246094 C 44.011719 54.628906 45.019531 57.242188 46.589844 59.796875 Z M 46.589844 59.796875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.137255%,18.431373%)",
      fillOpacity: 1
    },
    d: "M 12.378906 98.25 C 12.617188 96.929688 15.878906 56.417969 17.449219 55.714844 C 18.753906 55.125 37.164062 52.128906 44.8125 53.1875 C 46.355469 53.394531 50.890625 62.324219 51.660156 64.351562 C 52.402344 66.378906 57.234375 83.914062 56.996094 87.148438 C 56.761719 90.378906 54.449219 97.925781 54.328125 98.28125 C 54.210938 98.632812 12.378906 98.25 12.378906 98.25 Z M 12.378906 98.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,72.941176%,55.686275%)",
      fillOpacity: 1
    },
    d: "M 63.132812 35.210938 C 62.957031 39.914062 73.332031 41.882812 73.511719 38.855469 C 73.867188 32.890625 67.550781 12.035156 67.492188 10.535156 C 67.402344 8.6875 64.527344 5.925781 64.410156 3.839844 C 64.347656 2.78125 60.96875 0.519531 54.09375 4.542969 C 51.453125 6.101562 53.527344 7.65625 52.460938 7.953125 C 51.394531 8.246094 54.09375 12.003906 56.136719 12.917969 C 55.21875 13.0625 59.753906 13.386719 60.792969 13.503906 C 62.183594 13.679688 63.164062 34.597656 63.132812 35.210938 Z M 63.132812 35.210938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.137255%,18.431373%)",
      fillOpacity: 1
    },
    d: "M 64.765625 34.300781 C 70.457031 37.265625 74.84375 36.796875 75.613281 37.53125 C 76.5625 38.441406 75.613281 45.785156 74.339844 46.136719 C 73.066406 46.488281 60.226562 42.90625 59.695312 41.644531 C 59.160156 40.378906 60.910156 33.652344 61.859375 33.390625 C 62.925781 33.152344 64.765625 34.300781 64.765625 34.300781 Z M 64.765625 34.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,72.941176%,55.686275%)",
      fillOpacity: 1
    },
    d: "M 12.855469 40.410156 C 13.03125 45.109375 1.707031 43.054688 1.527344 40.058594 C 1.171875 34.09375 4.847656 13.355469 4.910156 11.859375 C 4.996094 10.007812 1.292969 5.570312 1.410156 3.484375 C 1.46875 2.429688 3.101562 -0.6875 11.3125 0.136719 C 14.367188 0.460938 13.476562 5.160156 12.527344 6.953125 C 13.445312 7.097656 12.230469 11.503906 11.195312 11.621094 C 9.800781 11.769531 12.824219 39.792969 12.855469 40.410156 Z M 12.855469 40.410156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.137255%,18.431373%)",
      fillOpacity: 1
    },
    d: "M 18.636719 75.308594 C 11.640625 86.734375 1.765625 56.773438 0.789062 44.492188 L 12.734375 43.523438 C 12.292969 46.636719 14.011719 46.136719 15.820312 49.371094 C 18.84375 54.773438 25.78125 63.617188 18.636719 75.308594 Z M 18.636719 75.308594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,91.764706%,64.705882%)",
      fillOpacity: 1
    },
    d: "M 7.429688 39.824219 C 3.929688 39.941406 2.476562 36.710938 1.558594 36.210938 C -0.160156 35.242188 -0.398438 44.554688 0.550781 45.433594 C 1.945312 46.726562 12.082031 46.492188 12.972656 45.433594 C 14.515625 43.613281 13.003906 36.769531 12.585938 37.679688 C 11.640625 39.675781 10.925781 39.707031 7.429688 39.824219 Z M 7.429688 39.824219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,72.941176%,55.686275%)",
      fillOpacity: 1
    },
    d: "M 25.277344 45.230469 C 24.980469 46.726562 28.269531 56.65625 28.804688 57.480469 C 28.894531 57.625 30.523438 84.5625 49.703125 77.777344 C 52.226562 76.898438 40.632812 64.824219 40.632812 64.824219 C 40.632812 64.824219 39.089844 52.75 43.714844 50.515625 C 43.953125 50.398438 44.308594 49.519531 43.210938 49.136719 C 38.765625 47.636719 25.277344 45.230469 25.277344 45.230469 Z M 25.277344 45.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20%,20%,20%)",
      fillOpacity: 1
    },
    d: "M 48.488281 75.808594 C 55.097656 70.84375 41.136719 60.121094 44.070312 49.898438 C 44.191406 49.519531 33.011719 57.539062 41.078125 66.113281 C 49.171875 74.722656 48.339844 75.925781 48.488281 75.808594 Z M 48.488281 75.808594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 31.472656 98.898438 C 32.300781 98.425781 40.632812 80.273438 39.921875 78.246094 C 44.25 79.214844 49.972656 77.070312 49.792969 75.925781 C 50.890625 76.628906 59.101562 85.503906 53.441406 98.546875 Z M 31.472656 98.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,72.941176%,55.686275%)",
      fillOpacity: 1
    },
    d: "M 44.929688 37.09375 C 48.074219 44.964844 47.152344 50.046875 40.722656 51.074219 C 34.257812 52.105469 22.933594 49.167969 21.570312 40.792969 C 20.207031 32.421875 25.039062 25.3125 31.589844 25.167969 C 39.859375 25.019531 41.015625 27.253906 44.929688 37.09375 Z M 44.929688 37.09375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(30.196078%,30.196078%,30.196078%)",
      fillOpacity: 1
    },
    d: "M 24.445312 27.222656 C 30.703125 24.3125 35.03125 21.492188 40.988281 27.574219 C 42.558594 29.191406 42.234375 30.101562 41.996094 30.367188 C 41.9375 30.425781 41.582031 29.691406 40.960938 29.074219 C 39.597656 27.722656 34.171875 24.109375 30.140625 26.695312 C 28.332031 27.867188 26.34375 31.453125 26.964844 41.292969 C 27.53125 49.960938 30.285156 63.238281 32.628906 66.996094 C 34.972656 70.757812 35.742188 72.3125 40.574219 73.8125 C 40.574219 73.8125 32.183594 82.359375 20.445312 57.949219 C 19.109375 55.1875 15.285156 48.667969 15.316406 48.550781 C 18.519531 36.976562 17.71875 30.367188 24.445312 27.222656 Z M 24.445312 27.222656 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccessfulResponsive);
export default __webpack_public_path__ + "static/media/icon_successful_responsive.3da823c50d4b042a2695fa87bde22264.svg";
export { ForwardRef as ReactComponent };